import { render, staticRenderFns } from "./manureRight2.vue?vue&type=template&id=1dac30b8&scoped=true&"
import script from "./manureRight2.vue?vue&type=script&lang=js&"
export * from "./manureRight2.vue?vue&type=script&lang=js&"
import style0 from "./manureRight2.vue?vue&type=style&index=0&id=1dac30b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac30b8",
  null
  
)

export default component.exports